import { themeColorSet, ThemedView } from '@app/theme';
import {
  CheckCircle,
  X,
  CaretUp,
  CaretDown,
  CaretLeft,
  ArrowLeft,
  CaretRight,
  ArrowUpRight,
  ArrowDownLeft,
  Warning,
  WarningCircle,
  RadioButton,
  Circle,
  Info,
  ArrowsCounterClockwise,
  CaretCircleRight,
  ClockCounterClockwise,
  Plus,
  Minus,
  FunnelSimple,
  MagnifyingGlass,
  PencilSimple,
  ArrowsLeftRight,
  Clock,
  Right,
  ArrowDown,
  ArrowUp
} from '@phosphor-icons/react';

const DebitIcon = ()=>(<ThemedView p="sm" borderRadius='full' justifyContent='center' alignItems='center' borderWidth={1}  borderColor='border-secondary'>
    <ArrowUpRight size={20} color={themeColorSet['icon-primary']} />
</ThemedView>
)

const CreditIcon = ()=>(
<ThemedView p="sm" borderRadius='full' justifyContent='center' alignItems='center' borderWidth={1}  borderColor='border-secondary'>
<ArrowDownLeft size={20} color={themeColorSet['icon-primary']} />
</ThemedView>)

export { CheckCircle, X, CaretUp, CaretDown, CaretLeft, ArrowLeft,ArrowUpRight,ArrowDownLeft,
   Warning,WarningCircle,Info,RadioButton,Circle,CaretRight,ArrowsCounterClockwise,CreditIcon,DebitIcon,
   ClockCounterClockwise,Plus,Minus,FunnelSimple,MagnifyingGlass,PencilSimple,CaretCircleRight,ArrowsLeftRight,Clock,Right,ArrowDown,ArrowUp };
